import { Banner, Languages } from '../../../react4xp/parts/admin-banners/admin-banners.type';

export const languages: Record<Languages, string> = {
    ru: 'Русский',
    en: 'English',
    kk: 'Қазақша',
    qq: 'Qazaqsha',
};

export const emptyValues: Banner = {
    id: 'empty',
    title_ru: '',
    title_en: '',
    title_kk: '',
    title_qq: '',
    url_ru: '',
    url_en: '',
    url_kk: '',
    url_qq: '',
    imageId: null,
    displayed: false,
};

export const IMAGE_TYPE = 'image/png';
